import React, { useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import ShowimagesLoading from "./showImagesLoading";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["printerLabel1"]?.[key] || fallback;

class ComponentToPrint extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            url_label : props.url_label
        };
    }


    render() {
        const {url_label } = this.state

        const print = () => (
           
          

                <div style={{ width: "100%", height: "100%" }}>
                  
                    <ShowimagesLoading 
                        src={url_label}
                        alt={__elakayText("t001", "shipping label")}
                        style={{ height: "100%", width: "100%" }}
                    />
                 
                    {/* <h1>{infoSource.laguangeElakay('title', infoSource.languageAPI).noLabelOrder}</h1> */}
                  
                  
                </div>

            )

        return (
            <div>
                {print()}
            </div>
        );
    }
}

const Example = props => {
    const { url_label,  infoSource, setShowLabel} = props
    __setElakayInfoSource(infoSource);
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const printPage = () => (
        <ComponentToPrint 
        url_label={url_label}
        ref={componentRef}
        />
    )

    return (
        <div className="container" style={{ width: "100%" ,  overflow: 'scroll'}}>
            {printPage()}
            <button onClick={() => setShowLabel(false)}  className="w-25 my-3 py-1 btn btn-outline-dark btn-md btn-block rounded-4 float-left">
                            {/* cancel */}
                        {infoSource.language(infoSource, "Button", "cancel")}
            </button>
            <button className="w-50 my-3 py-1 btn btn-outline-dark btn-md btn-block rounded-4 float-right" onClick={handlePrint}>
            {infoSource.language(infoSource, 'Button', "printThisOut")}
                </button>
        </div>
    );
};

export default Example;